module.exports = __webpack_public_path__ + "img/1728350340169-Screenshot_8-10-2024_91847_www.instagram.com.jpeg.e1582dad.webp";